module.exports = __webpack_public_path__ + "img/quan2.53d7a438.png";